<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Jjv2iO/tc-custom/9781501155475.jpg?1730523005770" alt="This image is the cover for the book Miracles and Other Reasonable Things"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Miracles and Other Reasonable Things
      </h1>
      <p class="bookDescription body article font2">
        <b>“This book—the fullness, depth, and beauty of Sarah Bessey’s faith and artistic genius—is a miracle” (Glennon Doyle, #1 <i>New York Times</i> bestselling author of <i>Love Warrior</i>) and an unforgettable and life-affirming exploration of how trauma can strengthen your faith and miracles can be found in unexpected places. </b><br/><br/>In the brief instant Sarah Bessey realized that her minivan was, inevitably, going to hit the car on the highway on the bright, clear day of the crash, she knew intuitively that it would have life-changing consequences. But as she navigated the winding path from her life before the accident—as a popular author, preacher, and loving wife and mother—to her new life after, inhabiting a body that no longer felt like her own, she found that the most unexpected result was how it shook her deeply rooted faith, upending everything she thought she knew and held so dearly.<br/><br/>Weaving together theology and memoir, Sarah delivers “a well-written reminder of seeing the miracles in life’s highs and lows” (<i>Library Journal</i>). The road of healing leads to Rome where she met the Pope (it’s complicated) and encountered the Holy Spirit in the last place she expected. She writes about her miraculous healing, learning to live with chronic pain, and the ways God makes us whole in the midst of suffering. She invites us to a path of knowing God that is filled with ordinary miracles, hope in the face of overwhelming evidence to the contrary, and other completely reasonable things.<br/><br/>Insightful, profound, and unexpected, “Sarah’s writing is so breathtaking, sometimes you think you are reading poetry. The story is so thrilling, sometimes you think you are devouring a novel. And the Spirit she describes is so compelling, you’ll swear you experienced a revival. You won’t put it down once until you close the last page” (Jen Hatmaker, <i>New York Times</i> bestselling author).
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sarah Bessey
      </h2>
      
      <p class="authorDescription body article">Sarah Bessey is the author of the popular and critically acclaimed books, <I>Out of Sorts: Making Peace with an Evolving Faith</I>, <I>Jesus Feminist</I>, and <I>Miracles and Other Reasonable Things</I><I>. </I>She is a sought-after speaker at churches, conferences, and universities all around the world. Sarah is also the cocurator and cohost of the annual Evolving Faith Conference and she serves as President of the Board for Heartline Ministries in Haiti. Sarah lives in Abbotsford, British Columbia, with her husband and their four children.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Howard Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1b951735